<template>
  <v-layout row wrap class="pt-3">
    <form-dialog v-model="dialog" :title="formTitle" @input="reset">
      <v-sheet class="py-2 px-4">
        <v-text-field
          data-vv-name="name"
          label="Project Name"
          v-model="project.name"
          v-validate="'required'"
          :data-vv-as="$t('name')"
          :error-messages="errors.collect('name')"
        />
        <date
          clearable
          :label="$t('start_date')"
          v-model="project.start_date"
        />
        <date :label="$t('end_date')" v-model="project.end_date" clearable />

        <v-textarea
          rows="1"
          auto-grow
          auto-height
          :label="$t('location')"
          v-model="project.location"
        />
        <v-textarea
          rows="1"
          auto-grow
          auto-height
          :label="$t('budget')"
          v-model="project.budget"
        />
        <v-textarea
          rows="1"
          auto-grow
          auto-height
          :label="$t('donor')"
          v-model="project.donor"
        />
        <v-textarea
          rows="1"
          auto-grow
          auto-height
          :label="$t('core_objectives')"
          v-model="project.core_objectives"
        />
        <v-flex xs12 class="flex-row">
          <v-checkbox
            color="teal"
            label="Completed"
            v-model="project.completed"
          />
        </v-flex>

        <div class="my-2 di-flex justify-end">
          <v-btn color="btn_color secondary" :loading="loading" @click="save">{{
            $t("save")
          }}</v-btn>
        </div>
      </v-sheet>
    </form-dialog>

    <v-flex xs12 mt-5 class="di-flex justify-space-between align-center">
      <strong class="title_label">{{ $t("projects") }}</strong>
      <v-spacer />
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            v-on="on"
            class="shadow"
            color="primary"
            v-if="can('edit_CSOs')"
            @click="dialog = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Add New Item</span>
      </v-tooltip>
    </v-flex>

    <v-flex xs12>
      <v-data-table
        item-key="id"
        hide-actions
        :items="items"
        :headers="headers"
        disable-initial-sort
      >
        <template slot="items" slot-scope="props">
          <td :class="{ success: props.item.completed }">
            {{ props.index + 1 }}
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.start_date }}</td>
          <td>{{ props.item.end_date }}</td>
          <td>{{ props.item.location }}</td>
          <td>{{ props.item.budget }}</td>
          <td>{{ props.item.donor }}</td>
          <td>{{ props.item.core_objectives }}</td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  flat
                  small
                  v-on="on"
                  class="ma-0 pa-0"
                  color="grey darken-2"
                  v-if="can('edit_CSOs')"
                  @click="editItem(props.item)"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  flat
                  small
                  v-on="on"
                  class="ma-0 pa-0"
                  color="grey darken-2"
                  v-if="can('edit_CSOs')"
                  @click="deleteItem(props.item)"
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </template>
        <template v-slot:no-data>
          <h4 class="text-xs-center grey--text text-darken-3">
            No running projects for the time being.
          </h4>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "CSOProjects",
  props: { value: Object },
  data() {
    return {
      items: [],
      project: {},
      dialog: false,
      loading: false,
      editedIndex: -1
    };
  },
  computed: {
    headers: vm => [
      { text: vm.$t("id"), sortable: false, width: "100px" },
      { text: "Project Name", value: "name" },
      { text: vm.$t("start_date"), value: "start_date" },
      { text: vm.$t("end_date"), value: "end_date" },
      { text: vm.$t("location"), value: "location" },
      { text: vm.$t("budget"), value: "budget" },
      { text: vm.$t("donor"), value: "donor" },
      { text: vm.$t("core_objectives"), value: "core_objectives" },
      { text: vm.$t("actions"), sortable: false, width: "200px" }
    ],

    formTitle: vm => (vm.editedIndex > -1 ? "Edit Project" : "New Project")
  },

  methods: {
    deleteItem(item) {
      let vm = this;
      this.$alert(`/projects/${item.id}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.project = Object.assign({}, item);
      this.dialog = true;
    },

    reset() {
      this.project = {
        id: null,
        name: null,
        donor: null,
        budget: null,
        location: null,
        end_date: null,
        start_date: null,
        core_objectives: null,
        CSO_id: this.$route.params.id
      };
      this.dialog = false;
      this.loading = false;
      this.editedIndex = -1;
      this.$validator.reset();
    },

    save() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.axios
            .post("projects", this.project)
            .then(res => {
              if (this.editedIndex > -1)
                Object.assign(this.items[this.editedIndex], res.data.data);
              else this.items.push(res.data.data);
              this.reset();
            })
            .catch(() => (this.loading = false));
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    }
  },

  created() {
    this.reset();
    let CSO_id = this.$route.params.id;
    this.axios.get(`projects?CSO_id=${CSO_id}`).then(res => {
      this.items = res.data.data;
    });
  }
};
</script>
